<!--
 * @Author: Junchi Zhao
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Description: 图标模板
-->
<template>
  <div :class="className" :style="{ width: width }" style="height:100%;" />
</template>

<script>
import * as echarts from "echarts";
import * as echartsGL from "echarts-gl";
import tools from "./js/tools"; //引入tools.js
export default {
  props: {
    //自定义className
    className: {
      type: String,
      default: "chart"
    },
    width: {
      type: String,
      default: "100%"
    },
    height: {
      type: String,
      default: "100%"
    },
    //图表的option
    chartData: {
      type: Object,
      required: true
    },
    //是否开启提示框轮播
    sflb: {
      type: Object,
      required: false
    },
    //轮播数量
    lbsl: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      chart: null
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        if (val && Object.keys(val).length > 0 && this.chart) {
          this.chart.dispose();
          this.chart = null;
          this.chart = echarts.init(this.$el);
          this.chart.setOption(val);
        }
      }
    },
    lbsl: {
      deep: true,
      handler(val) {
        if (this.sflb) {
          if (this.lbsl > 0) {
            tools.autoHover(this.chart, this.chartData, this.lbsl, 3000);
          }
        }
      }
    }
  },
  mounted() {
    //初始化监听窗口resize时间 重绘图表
    this.$nextTick(() => {
      this.initChart();
      window.addEventListener("resize", this.handler);
    });
  },
  //页面销毁时回收内存
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    window.removeEventListener("resize", this.handler);
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    handler() {
      if (this.chart) {
        this.chart.resize();
      }
    },
    registerMap(name, json) {
      echarts.registerMap(name, json);
    },
    //初始化图表
    initChart() {
      this.chart = echarts.init(this.$el);
      if (
        this.chartData &&
        Object.keys(this.chartData).length > 0 &&
        this.chart
      ) {
        console.log(this.chartData);
        this.chart.setOption(this.chartData);
        if (this.sflb) {
          if (this.lbsl > 0) {
            tools.autoHover(this.chart, this.chartData, this.lbsl);
          }
        }
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/charts/index.vue